import { useTheme } from '@mui/material';
import { LocationOn } from '@mui/icons-material';
import Box from '@/components/ui/Box/Box';
import Card from '@/components/ui/Card/Card';
import Typography from '@/components/ui/Typography/Typography';
import type { LocationCardProps } from './ILocationCard';
import { styles } from './styles';

const fallbackName = (loc: { city?: string | null; state?: string | null }) =>
    `${loc.city ?? ''} ${loc.state ?? ''}`.trim() || 'Untitled location';

const LocationCard = ({ location, isActive, onClick }: LocationCardProps) => {
    const theme = useTheme();
    const title = location.nickname?.trim() || fallbackName(location);
    const address =
        location.formatted_address?.trim() ||
        [
            location.street_number,
            location.street_name,
            location.city,
            location.state,
            location.zip,
        ]
            .filter(Boolean)
            .join(', ');
    const contactName = location.contact_info?.name ?? '';

    return (
        <Card sx={styles.card(isActive)} onClick={() => onClick(location.id)}>
            <Box sx={styles.iconBadge(isActive, theme)}>
                <LocationOn />
            </Box>
            <Box sx={styles.body}>
                <Typography sx={styles.nickname}>{title}</Typography>
                {address && <Typography sx={styles.address}>{address}</Typography>}
                {contactName && <Typography sx={styles.contact}>{contactName}</Typography>}
            </Box>
        </Card>
    );
};

export default LocationCard;
